export default "./src/client/components/auth/login/open-web/cie-button/img/cie-icon.png?b814583934720e2db00d36a961f7b807";